import { createTerraOrpcClient } from '@terra/shared-utils';
import { CommentsContract } from '@terra/shared-contracts-comments';

const SERVICE_NAME = 'orchestrator';

export const commentsClient = createTerraOrpcClient({
  contract: CommentsContract,
  serviceName: SERVICE_NAME,
});
